import { Link, Notice, Table, Text } from "@smooth/design-system-components"
import { useRouter } from "next/router"
import { usePayments } from "../hooks/usePayments"
import { PaymentReconciliations } from "./PaymentReconciliations"
import Pagination from "src/components/tailwind-components/Pagination"

const COLUMNS = [
  { key: "reconciliations", header: "Reconciliations" },
  { key: "user", header: "User" },
  { key: "id", header: "Id" },
]

/** 入金の一覧。admin と同じ列を ID の新しい順に出す。新規作成は無い（入金は手動消込で作る） */
export const PaymentList = ({ page }: { page: number }) => {
  const router = useRouter()
  const { payments, pagination, error, isLoading } = usePayments(page)

  if (error) return <Notice tone="error">一覧を取得できませんでした</Notice>
  if (isLoading) return <Text>読み込み中...</Text>

  const rows = payments.map((payment) => ({
    id:
      payment.id === null ? null : <Link href={`/admin/payments/${payment.id}`}>{payment.id}</Link>,
    user:
      payment.userId === null ? null : (
        <Link href={`/admin/users/${payment.userId}`}>{payment.userId}</Link>
      ),
    reconciliations: <PaymentReconciliations reconciliations={payment.reconciliations} />,
  }))

  return (
    <div className="flex flex-col gap-4">
      <Table
        columns={COLUMNS}
        rows={rows}
        onRowClick={(index) => router.push(`/admin/payments/${payments[index].id}`)}
      />
      <Pagination
        pagination={{
          currentPage: page,
          totalPages: pagination?.totalPages ?? 1,
          totalCount: pagination?.totalCount ?? 0,
        }}
        onPageChange={(next) => router.push({ query: { ...router.query, page: next } })}
      />
    </div>
  )
}
